import { useMutation } from "@tanstack/react-query";

import { signUpWithEmail } from "@/shared/requests/auth";

export function usePreSignInEmail() {
  const mutationFn = async ({ email }: { email: string }) => {
    try {
      await signUpWithEmail({ email });
    } catch (error: unknown) {
      const status = (error as { status?: number })?.status;
      if (status === 400 || status === 500) {
        return Promise.resolve();
      }
      return Promise.reject(error);
    }
  };
  return useMutation(mutationFn);
}
